import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { replaceElements } from '@mfe-4cs/components/templates/util';
import { html, nothing, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export function mainTemplate(this: TefComs4csMicroFrontend): TemplateResult {
  const historyTemplate = this.getTemplateFn('historyTemplate');
  const groupTemplate = this.getTemplateFn('groupTemplate');
  const groupTemplateOverview = this.getTemplateFn('groupTemplateOverview');
  const referencesTemplate = this.getTemplateFn('referencesTemplate');

  return html`
    <one-stack name="main">
      ${this.showReferences ? referencesTemplate(this.store.references) : nothing}
      ${this.store.history?.configId
    ? historyTemplate()
    : this.store.consentGroups?.map(
      (group) => (this.mode === 'overview'
        ? groupTemplateOverview(group)
        : groupTemplate(group)),
    )}
      ${((this.store.consentGroups?.length ?? 0) > 0 && this.store.details?.pageFooter)
    ? html`<p>${unsafeHTML(replaceElements.bind(this)(this.store.details.pageFooter))}</p>`
    : nothing}
    </one-stack>
  `;
}
